import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormFull = _resolveComponent("FormFull");
    const _component_Popup = _resolveComponent("Popup");
    return (_ctx.renderInnerPopup)
        ? (_openBlock(), _createBlock(_component_Popup, {
            key: 0,
            title: _ctx.infoPayload.title,
            modelValue: _ctx.openToUse,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.openToUse) = $event)),
            cancelBtnTxt: _ctx.cancelBtnTxt,
            actionBtnTxt: _ctx.actionBtnTxt,
            actionBtnTxt2: _ctx.actionBtnTxt2,
            actionBtnTxt3: _ctx.actionBtnTxt3,
            actionBtnTxt4: _ctx.actionBtnTxt4,
            isActionBtnEnabled: _ctx.validateUserInputs,
            prohibitCancel: _ctx.prohibitCancel,
            variant: _ctx.variant,
            onOnDone: _ctx.onPopupDone,
            onOnDone2: _ctx.onPopupDone2,
            onOnDone3: _ctx.onPopupDone3,
            onOnDone4: _ctx.onPopupDone4,
            onOnClosed: _ctx.onClosed,
            onOnCancel: _ctx.onPopupCancel,
            id: 'modal-' + _ctx.infoPayload.pluginId,
            modalWidth: _ctx.modalWidth,
            submitOnEnter: _ctx.submitOnEnter
        }, {
            default: _withCtx(() => [
                (_ctx.infoPayload.intro !== '')
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        innerHTML: _ctx.infoPayload.intro +
                            ' '
                            + (_ctx.infoPayload.details ? _ctx.infoPayload.details : '')
                    }, null, 8, _hoisted_1))
                    : _createCommentVNode("", true),
                (_ctx.citationsTxt !== '')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        innerHTML: _ctx.citationsTxt
                    }, null, 8, _hoisted_2))
                    : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "default"),
                _createVNode(_component_FormFull, {
                    ref: "formfull",
                    id: _ctx.infoPayload.pluginId,
                    modelValue: _ctx.userArgsFixed,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.userArgsFixed) = $event)),
                    onOnChange: _ctx.onChange,
                    hideIfDisabled: _ctx.hideIfDisabled
                }, null, 8, ["id", "modelValue", "onOnChange", "hideIfDisabled"]),
                _renderSlot(_ctx.$slots, "afterForm")
            ]),
            _: 3
        }, 8, ["title", "modelValue", "cancelBtnTxt", "actionBtnTxt", "actionBtnTxt2", "actionBtnTxt3", "actionBtnTxt4", "isActionBtnEnabled", "prohibitCancel", "variant", "onOnDone", "onOnDone2", "onOnDone3", "onOnDone4", "onOnClosed", "onOnCancel", "id", "modalWidth", "submitOnEnter"]))
        : _createCommentVNode("", true);
}
